//import Swal from "sweetalert2";
//import Vue from "vue";

import {
    addEquivalentCode,
    addProperty, addStockCategory, deleteStockCategory,
    getCurrentStockActionList,
    getEquivalentCodeList,
    getSingleStock,
    getStockActionList,
    getStockCategoryList, getStockCategorySingle,
    getStockCodes,
    getStockImage,
    getStockList,
    searchStockList,
    updateEquivalentCode,
    updateProperty, updateStockCategory, deleteStockImage,
} from "../../services/modules/stock/stockService";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "../alertHelpers.js";
import {numberConverter} from "../../../helpers";
import store from "@/state/store";


export const state = {
    currentStockActionList: [],
    currentStockActionListHeaders: [],
    currentStockActionListLoading: false,
    stockCategoryList: [],
    stockCategoryListHeaders: [],
    stockCategoryListLoading: false,
    stockList: [],
    stockListMetaData: [],
    stockListHeaders: [],
    stockListHeadersPreset: [],
    stockListLoading: false,
    stockActionList: [],
    stockActionListHeaders: [],
    stockActionListLoading: false,
    singleStock: {},
    singleStockLoading: false,
    singleStockHeaders: [],
    equivalentCodeList: [],
    noStockMessage: "Lütfen Arama Yapınız",
};

export const mutations = {
    setNoStockMessage(state, data) {
        state.noStockMessage = data;
    },
    setCurrentStockActionList(state, data) {
        state.currentStockActionList = data;
    },
    setCurrentStockActionListHeaders(state, data) {
        state.currentStockActionListHeaders = data;
    },
    setCurrentStockActionListLoading(state, data) {
        state.currentStockActionListLoading = data;
    },
    setStockCategoryList(state, data) {

        state.stockCategoryList = data;
    },
    setStockCategoryListHeaders(state, data) {
        state.stockCategoryListHeaders = data;
    },
    setStockCategoryListLoading(state, data) {
        state.stockCategoryListLoading = data;
    },
    setStockList(state, data) {
        state.stockList = data;
    },
    setStockListMetaData(state, data) {
        state.stockListMetaData = data;
    },
    setStockListHeaders(state, data) {
        state.stockListHeaders = data;
    },
    setStockListHeadersPreset(state, data) {
        state.stockListHeadersPreset = data;
        state.stockListHeaders = data;
    },
    setStockListLoading(state, data) {
        state.stockListLoading = data;
    },
    setStockActionList(state, data) {
        state.stockActionList = data;
    },
    setStockActionListHeaders(state, data) {
        state.stockActionListHeaders = data;
    },
    setStockActionListLoading(state, data) {
        state.stockActionListLoading = data;
    },
    setSingleStock(state, data) {
        state.singleStock = data;
    },
    setSingleStockHeaders(state, data) {
        state.singleStockHeaders = data;
    },
    setSingleStockLoading(state, data) {
        state.singleStockLoading = data;
    },
    setEquivalentCodeList(state, data) {
        state.equivalentCodeList = data;
    },
    setSingleStockItem(state, data) {
        let stock = state.stockList.find(item => item.code === data.code);
        if (stock && data) {
            stock = data;
        }
    }
}

export const getters = {
    getSingleStockItem(state, code) {
        return state.stockList.find(item => item.code === code);
    }
};

export const actions = {
    async fetchStockActionList(context, {params, body}) {
        context.commit("setStockActionListLoading", true)
        let result = await getStockActionList(params, body);
        let headers = [
            {
                key: 'actionDate',
                label: 'Tarih',
                sortable: false,

            },
            {
                key: 'documentNumber',
                label: 'Belge No',
                sortable: true,

            },
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: true,

            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: true,

            },
            {
                key: 'currentName',
                label: 'Cari',
                sortable: true,

            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: true,

            },
            {
                key: 'actionType',
                label: 'Satış / Alış',
                sortable: true,

            },
            {
                key: 'unitPrice',
                label: 'Fiyat',
                sortable: true,
                class: 'text-right',

            },
        ];

        if (store.state.settings.erpSettings.netsisCurrencySale) {
            headers.push({
                key: 'currencyUnitPrice',
                label: 'Dövizli Fiyat',
                sortable: true,
                class: 'text-right',
            });
        }
        context.commit('setStockActionListHeaders', headers);
        context.commit("setStockActionListLoading", false)
        if (result.data.success) {
            let stockActionData = {}
            if (store.state.auth.user.RoleGroupId === 1 || store.state.auth.user.RoleGroupId === "1") {
                result.data.data.map(item => item.unitPrice = numberConverter(item.unitPrice))
                result.data.data.map(item => item.currencyUnitPrice = numberConverter(item.currencyUnitPrice))

                context.commit("setStockActionList", result.data.data);
            } else {
                stockActionData = result.data.data;
                stockActionData.map((item) => item.actionType === 2 ? item.unitPrice = '-' : item.unitPrice = numberConverter(item.unitPrice))
                stockActionData.map((item) => item.actionType === 2 ? item.currencyUnitPrice = '-' : item.currencyUnitPrice = numberConverter(item.currencyUnitPrice))
                context.commit("setStockActionList", stockActionData);
            }
        }

        return result.data.data;
    },
    async fetchStockList(context, {params, body, loading, onlyData}) {
        context.commit("setStockListLoading", true)
        let result = await getStockList({params: params, body: body, loading: loading});
        if (store.state.stock.stockListHeadersPreset.length>0){
            context.commit('setStockListHeaders', store.state.stock.stockListHeadersPreset)
            context.commit("setStockListLoading", false)

        }
        else {
            context.commit('setStockListHeaders', [
                {
                    key: 'images',
                    label: 'Resim',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle',
                },
                {
                    key: 'code',
                    label: 'Stok Kodu',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'name',
                    label: 'Stok Adı',
                    sortable: false,
                    visible: true,
                    class: 'text-left align-middle',
                },
                {
                    key: 'balance',
                    label: 'Bakiye',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: "denominator1",
                    label: "Koli İçeriği",
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'unitPrice',
                    label: 'Liste Fiyatı',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'discountUnitPrice',
                    label: 'İndirimli Fiyat',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'discount1',
                    label: 'İskonto 1 (%)',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'discount2',
                    label: 'İskonto 2 (%)',
                    sortable: false,
                    visible: true,
                    class: 'text-center align-middle text-nowrap',
                },
                // {
                //     key: 'units',
                //     label: 'Birim',
                //     sortable: false,
                //     visible: true,
                //     stickyColumn: false,
                //     class: 'text-center align-middle',
                // },
                {
                    key: 'amount',
                    label: 'Miktar',
                    sortable: false,
                    visible: true,
                    stickyColumn: false,
                    class: 'text-center align-middle text-nowrap',
                },
                {
                    key: 'processes',
                    label: 'İşlemler',
                    sortable: false,
                    visible: true,
                    stickyColumn: false,
                    class: 'text-center align-middle',
                }
            ]);
            context.commit("setStockListLoading", false)
        }

        if (result.data.success) {
            if (onlyData)
                return result.data.data;

            // result.data.data.forEach((item) => {
            //     item.maxDiscount = item.discount1
            // }); // Manuel olarak maxDiscount eklendi'
            result.data.data.map(item => {
                // let unitsArr = [];
                item.quantity = null;
                // item.selectedUnit = 1;
                //TODO : Birim seçimi burası ve header'daki units açılacak ile açılacak
                // if (item.units.includes(",")) {
                //     unitsArr = item.units.split(",").map((unit, index) => {
                //         return { value: index + 1, text: unit.trim() };
                //     });
                // } else {
                //     unitsArr.push({ value: 1, text: item.units.trim() });
                // }
                // item.units = unitsArr;
            });
            context.commit("setStockList", result.data.data);
            context.commit("setStockListMetaData", {
                totalCount: result.data.totalCount,
                totalPages: result.data.totalPages
            });
        } else {
            await context.commit("setStockList", []);
            await context.commit("setStockListMetaData", []);
            await context.commit("setNoStockMessage", result.data.message);
        }
    },
    async stockSearch(context, {params, body, loading, onlyData}) {

        let result = await searchStockList({params: params, body: body, loading: loading});
        if (result.data.success) {
            if (onlyData)
                return result.data.data;

        }

        return result.data.data;
    },
    async fetchStockCategoryList(context, {params, body, saltData}) {
        context.commit("setStockCategoryList", []);
        context.commit("setStockCategoryListLoading", true)
        let result = await getStockCategoryList(params, body);
        context.commit('setStockCategoryListHeaders', [
            {
                key: 'name',
                label: 'Kategori Adı',
                sortable: false,

            },
            {
                key: 'parentCategory',
                label: 'Üst Kategori',
                sortable: false,

            },
            {
                key: 'groupValue',
                label: 'Grup Kod',
                sortable: false,

            },
            {
                key: 'isActive',
                label: 'Durum',
                sortable: false,
            },
            {
                key: 'process',
                label: 'İşlem',
                sortable: false,
                class: "text-center"

            }
        ]);
        context.commit("setStockCategoryListLoading", false)
        if (saltData)
            return context.commit("setStockCategoryList", result.data.data);
        else
            return await context.dispatch("recursiveInitStockCategoryList", result.data.data);
    },
    async fetchCurrentStockActionList(context, {params, body}) {
        context.commit("setCurrentStockActionListLoading", true)
        let result = await getCurrentStockActionList(params, body);

        let headers = [
            {
                key: 'actionDate',
                label: 'Tarih',
                sortable: false,

            },
            {
                key: 'documentNumber',
                label: 'Belge No',
                sortable: false,

            },
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: false,

            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: false,

            },
            {
                key: 'currentName',
                label: 'Cari',
                sortable: false,

            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: false,
                class: 'text-right',


            },
            {
                key: 'actionType',
                label: 'Satış / Alış',
                sortable: false,
                class: 'text-right',

            },
            {
                key: 'unitPrice',
                label: 'Fiyat',
                sortable: true,
                class: 'text-right',
            },
        ];
        if (store.state.settings.erpSettings.netsisCurrencySale) {
            headers.push({
                key: 'currencyUnitPrice',
                label: 'Dövizli Fiyat',
                sortable: true,
                class: 'text-right',
            });
            headers.push({
                key: "currencyType",
                label: "Döviz Tipi",
                sortable: false,
                class: "text-center"
            })
        }

        context.commit('setCurrentStockActionListHeaders', headers);
        context.commit("setCurrentStockActionListLoading", false)
        if (result.data.success) {
            let currentStockActionData = {}

            if (store.state.auth.user.RoleGroupId === 1 || store.state.auth.user.RoleGroupId === "1") {
                result.data.data.map(item => item.unitPrice = numberConverter(item.unitPrice))
                result.data.data.map(item => item.currencyUnitPrice = numberConverter(item.currencyUnitPrice))
                context.commit("setCurrentStockActionList", result.data.data);
            } else {
                currentStockActionData = result.data.data;
                currentStockActionData.map((item) => item.actionType === 2 ? item.unitPrice = '-' : item.unitPrice = numberConverter(item.unitPrice))
                currentStockActionData.map((item) => item.actionType === 2 ? item.currencyUnitPrice = '-' : item.currencyUnitPrice = numberConverter(item.currencyUnitPrice))
                context.commit("setCurrentStockActionList", currentStockActionData);
            }
            return result.data.data;
        }else{
            context.commit("setCurrentStockActionList", []);
            await context.commit("setNoStockMessage", result.data.message);
            return result.data.data;
        }

    },
    async fetchSingleStock(context, {params, body}) {
        context.commit("setSingleStockLoading", true)
        let result = await getSingleStock(params, body);
        let headers = [
            {
                key: 'fileUrl',
                label: 'Dosya İsmi',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'process',
                label: 'İşlem',
                sortable: false,
                class: "text-center align-middle"
            }
        ];
        context.commit("setSingleStockHeaders",headers);
        context.commit("setSingleStockLoading", false);
        if (result.data.success) {
            context.commit("setSingleStock", result.data.data);
        }

        return result.data.data;
    },
    async fetchSingleStockCategory(context, {params, body, urlSegments}) {

        let result = await getStockCategorySingle(params, body, urlSegments);

        if (result.data.success) {
            return result.data.data;
        } else return {}

    },
    async fetchStockCodes(context, {params, body}) {

        let result = await getStockCodes({params, body});
        if (result.data.success) {
            return result.data.data;
        }

        return [];
    },
    async fetchStockImage(context, {params, body, urlSegments, urlConcat}) {
        let result = await getStockImage(params, body, urlSegments, urlConcat);
        return result.data.data;
    },
    async stockCategoryAdd(context, {params, body}) {

        let result = await addStockCategory(params, body);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        return result;
    },
    async stockCategoryUpdate(context, {params, body}) {

        let result = await updateStockCategory(params, body);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        return result;
    },
    async stockCategoryDelete(context, {params, body, urlSegments}) {

        await showProcessPromptMessage({
            title: 'Kategori Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteStockCategory(params, body, urlSegments);
                    if (result.data.success)
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message,
                        }).then(
                            context.dispatch('fetchStockCategoryList', {
                                params: {},
                                body: {},
                            })
                        );
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message,
                        });

                    return result;
                }
            }
        )
    },
    async fetchEquivalentCodeList(context, {params, body}) {

        let result = await getEquivalentCodeList(params, body);
        if (result.data.success) {
            context.commit("setEquivalentCodeList", result.data.data);
        } else {
            context.commit("setEquivalentCodeList", []);
        }

        return result.data.data;
    },
    async equivalentCodeAdd(context, {params, body}) {

        let result = await addEquivalentCode(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        return result;
    },
    async equivalentCodeUpdate(context, {params, body}) {

        let result = await updateEquivalentCode(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }
        return result;
    },
    async propertyAdd(context, {params, body}) {

        let result = await addProperty(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        return result;
    },
    async propertyUpdate(context, {params, body}) {

        let result = await updateProperty(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }
        return result;
    },

    async recursiveInitStockCategoryList(context, list) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].subCategories != null) {
                for (let j = 0; j < list[i].subCategories.length; j++) {
                    list.push(list[i].subCategories[j]);
                }
                await context.dispatch("recursiveInitStockCategoryList", list[i].subCategories);
            }
        }
        context.commit("setStockCategoryList", list);
        return list;
    },

    async stockImageDelete(context, {params, body, urlSegments}) {

        await showProcessPromptMessage({
            title: 'Dosya Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteStockImage(params, body ,urlSegments);
                    if (result.data.success)
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message,
                        })
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message,
                        });

                    return result;
                }
            }
        )
    },

};
